/**
 * Created by ah on 04/01/17.
 */
import api from '../apiClient';
import {Keys, Actions} from '../constants';
import {defaultAsyncActionFactory} from './action-utils'

export const loadWorkSessionTemplates =  defaultAsyncActionFactory(
    Actions.GET_WORK_SESSION_TEMPLATES,
    Keys.StoreSliceData.WORK_SESSION_TEMPLATES,
    api.getWorkSessionTemplates
);


// WEBPACK FOOTER //
// ./src/model/action-creators/work-session-template-actions.js